import { render, staticRenderFns } from "./guide-view-toolbar.vue?vue&type=template&id=514a5721&scoped=true&"
import script from "./guide-view-toolbar.vue?vue&type=script&lang=js&"
export * from "./guide-view-toolbar.vue?vue&type=script&lang=js&"
import style0 from "./guide-view-toolbar.vue?vue&type=style&index=0&id=514a5721&lang=scss&scoped=true&"
import style1 from "./guide-view-toolbar.vue?vue&type=style&index=1&id=514a5721&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514a5721",
  null
  
)

export default component.exports
import {QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBtn})
